import ajax from 'Site/js/util/ajax.fetch';
import coverImageMixin from 'Site/js/mixin/cover.image';
import dropdownDirective from 'Site/directive/dropdown';
import Editable from 'Site/component/Editable.vue';
import reportDirective from 'Abuse/directive/report';
import store from 'Site/js/store';
import Vue from 'vue';
import { mapActions, mapState } from 'vuex';
import subscribeMixin from '../js/mixin/subscribe';


export default function () {
    new Vue({ /* eslint no-new:0 */
        el: '#club-header',
        name: 'clubHeader',
        store,
        components: {
            Editable
        },
        computed: {
            ...mapState({
                clubAjaxParams: state => ({ url: 'club', id: state.config.data.id }),
                config: state => state.config,
                t: state => state.t
            }),
            reportData() {
                return {
                    id: this.config.data.id,
                    title: this.t.report_title,
                    type: this.config.data.reportType,
                    user: this.config.data.owner ? this.config.data.owner : null
                };
            }
        },
        directives: {
            dropdown: dropdownDirective,
            report: reportDirective
        },
        methods: {
            ...mapActions(['notify', 'sendMessage', 'showConfirm']),
            changeCoverImage(coverImage) {
                this.showCoverImageModal = false;
                this.coverImage = coverImage.url;
                if (coverImage.upload) {
                    this.notify({ msg: this.t.cover_image_awaiting_approval });
                    return;
                }
                let params = { id: this.id, cover: coverImage.id };
                if (coverImage.site) {
                    params = { id: this.id, theme: coverImage.name };
                }
                ajax.update('club', params).then(() => {
                    this.notify({ msg: this.t.cover_image_updated });
                });
            },
            deleteClub(text, url, redirect) {
                this.showConfirm({
                    text,
                    callback: () => {
                        ajax.delete(url).then(() => {
                            window.location = redirect;
                        });
                    }
                });
            }
        },
        mixins: [coverImageMixin, subscribeMixin]
    });
}
